import { api } from '@api'
import type { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'
import { Memory } from './usePaginateMemories'

interface AlbumMemoriesParams {
  albumId: string
}

// Per request: the album loads every page, so fewer round trips than the API's 10.
const PAGE_SIZE = 30

const fetchAlbumMemories = async (
  params?: FetchParams & AlbumMemoriesParams,
): Promise<PaginatedResponse<Memory>> => {
  const queryParams = new URLSearchParams()
  if (params?.pageParam) {
    queryParams.append('page', String(params.pageParam))
  }
  queryParams.append('limit', String(PAGE_SIZE))

  const url = `/albums/${params?.albumId}/memories?${queryParams.toString()}`
  const { data } = await api.get<PaginatedResponse<Memory>>(url)
  return data
}

export const usePaginateAlbumMemories = (params: AlbumMemoriesParams) => {
  return usePaginate<Memory>('album-memories', fetchAlbumMemories, params, {
    enabled: !!params.albumId,
    nextPageWhenFull: true,
  })
}
